import { TsDOM as q } from '@/scripts/core/TsDOM'
import { fetchConfig } from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { openPersonalizationPopup } from '@/scripts/core/global'
import { CartRemoveButton } from '@/scripts/cart/cart-remove-button'
import { CartDrawer } from '@/scripts/cart/cart-drawer'

export class CartEditButton extends UcoastEl {
    static htmlSelector = 'cart-edit-button'
    currentItem: HTMLElement
    button: HTMLButtonElement
    constructor() {
        super()
        this.currentItem = q.rc(this, '.cart-item')
        this.button = q.rs('button', this)

        this.addEventListener('click', (event) => {
            event.preventDefault()
            if(this.button.classList.contains('cart-item-gift')) {
                const cartNote = q.rs('custom-accordion[data-uc-cart-note-details]', document)
                this.currentItem.classList.add('hidden')
                cartNote.classList.remove('hidden')
                cartNote.setAttribute('open', '')
                cartNote.querySelector('summary')?.setAttribute('aria-expanded', 'true')
                cartNote.querySelectorAll('[name="note"]').forEach(note => {
                    note.value = this.dataset.note
                })
                const noteLength = this.dataset.note?.length ?? 0;
                cartNote.querySelector('.cart__note-field-count')!.textContent = `${noteLength} / 280`;

                const line = q.ra(this, 'data-index')
                const body = JSON.stringify({ line: line, quantity: 0 })

                fetch(`${window.routes.cart_change_url}`, {
                    ...fetchConfig(),
                    ...{ body }
                })
                .then((response) => {
                    return response.text()
                })
                .then((state) => {
                    const parsedState = JSON.parse(state)
                    console.log('parsedState', parsedState)
                })
                .catch((error) => {
                    console.error(error)
                })
            } else {
                const parentId = this.button.dataset.parentId
                if(!parentId) return
                const parentEl = q.rs(`.cart-item[data-id="${parentId}"]`, document)
                if(!parentEl) return
                const cartDrawer = q.rs('cart-drawer', document) as CartDrawer
                if(cartDrawer) cartDrawer.close()
                const productUrl = parentEl.dataset.url

                openPersonalizationPopup(String(productUrl), String(parentId))

                const removeButton = q.rs('cart-remove-button', parentEl) as CartRemoveButton
                removeButton.removeItem()
            }
        })
    }
}
